<template>
  <generic-modal :title="$t('account')" ref="generic_modal">
    <div class="title is-4" v-if="parent_account">
      {{ parent_account.number }} - {{ parent_account.name }}
    </div>
    <div class="title is-4" v-if="current_account">
      {{ current_account.number }} - {{ current_account.name }}
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("number") }}</label>
          <div class="control">
            <!-- <MaskInput
              class="input"
              v-model="meta.number"
              :mask="mask"
              :placeholder="mask"
              ref="mask_input"
            /> -->
            <input
              class="input"
              type="text"
              v-model="meta.number"
              :placeholder="mask"
            />
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("name") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.name" />
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("target") }}</label>
          <div class="control">
            <div class="select">
              <select v-model="meta.target">
                <option value="debtor">{{ $t("debtor") }}</option>
                <option value="creditor">{{ $t("creditor") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("type") }}</label>
          <div class="control">
            <div class="select">
              <select v-model="meta.type">
                <option value="accumulative">{{ $t("accumulative") }}</option>
                <option value="detail">{{ $t("detail") }}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("balance") }}</label>
          <div class="control">
            <input class="input" type="text" v-model="meta.balance" />
          </div>
        </div>
      </div>
    </div>
    <pre>{{ meta }}</pre>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "AccountingAccountModal",
  components: { GenericModal },
  data() {
    return {
      meta: { settings: {} },
      error: "",
      parent_account: undefined,
      current_account: undefined,
    };
  },
  props: {
    current_period: {
      type: Object,
      required: false,
    },
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name || !v.meta.target || !v.meta.type || !v.meta.number;
    },
    mask() {
      let v = this;

      if (v.current_period) {
        let number_of_levels = v.current_period.settings.number_of_levels;
        let digits_by_level = v.current_period.settings.digits_by_level;
        let n = Array(Number(digits_by_level)).fill("#").join("");
        let suggested_name = Array(Number(number_of_levels)).fill(n).join(".");
        return suggested_name;
      } else {
        return "##.###.#.####";
      }
    },
  },
  methods: {
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    edit_modal(uuid) {
      let v = this;
      v.set_initial_state();
      get("/accounting/account", { uuid: uuid })
        .then((account) => {
          v.current_account = { ...account };
          v.meta = account;
        })
        .catch((error) => {
          console.log(error);
          v.error = generate_error_message_text(error);
        });
      v.$refs.generic_modal.show_modal();
    },
    show_modal(parent_uuid) {
      let v = this;
      v.set_initial_state();

      if (parent_uuid) {
        get("/accounting/account", { uuid: parent_uuid })
          .then((account) => {
            v.parent_account = account;
            v.meta.parent_account_id = account.account_id;
            v.meta.number = account.number;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        let suggested_number = v.mask;
        // console.log(suggested_name);
        v.meta.number = suggested_number.replace(/#/g, "0");
      }

      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.period_uuid = v.$route.params.period_uuid;
      if (!v.meta.uuid) {
        put("/accounting/account", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else
        post("/accounting/account", data)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        parent_account_id: null,
        settings: {},
      };
      v.parent_account = undefined;
      v.current_account = undefined;
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
